// UI structure: Unified 3-level structure
// Level1: { id, name, expanded, children: Level2[] }
// Level2: { id, name, expanded, children: Level3[] }
// Level3: { id, name }

/**
 * Convert UI structure to backend batch payload for POST /folders
 * Backend expects: { folders: [{ name, children: [{ name, children: [{ name }] }] }] }
 */
export function uiToBatchFolders(structure) {
  if (!Array.isArray(structure)) return [];

  const mapLevel3 = (children = []) =>
    (children || []).map((a) => ({ name: a?.name || "" }));

  const mapLevel2 = (children = []) =>
    (children || []).map((l2) => ({
      name: l2?.name || "",
      ...(l2?.children && l2.children.length
        ? { children: mapLevel3(l2.children) }
        : {}),
    }));

  return structure.map((l1) => ({
    name: l1?.name || "",
    ...(l1?.children && l1.children.length
      ? { children: mapLevel2(l1.children) }
      : {}),
  }));
}
